import axios from "axios";
import { fetchDataFromLocalStorage, logout, setDataInLocalStorage } from "../utils/helpers";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

// Attach access token to all requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = fetchDataFromLocalStorage("accessToken");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor to handle 401
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // A rejected login is a 401 about the submitted credentials, not an expired
    // session, so it must surface to the page instead of triggering a refresh/logout.
    const isLoginRequest = originalRequest?.url?.includes("auth/login");

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      !isLoginRequest
    ) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return axiosInstance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = fetchDataFromLocalStorage("refreshToken");
      if (!refreshToken) {
        logout();
        return Promise.reject(error);
      }

      try {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}auth/refreshToken`, {
          oldRefreshToken: refreshToken,
        });
        const { accessToken, refreshToken: newRefreshToken } = response.data.data;

        setDataInLocalStorage("accessToken", accessToken);
        setDataInLocalStorage("refreshToken", newRefreshToken);

        axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;

        processQueue(null, accessToken);

        return axiosInstance(originalRequest);
      } catch (err) {
        processQueue(err, null);
        console.log("here 3", err);
        logout();
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
